function setAdminApi(path) {
  let global = '/api/';
  return global + path;
}

const api = {
  // 是否黑白
  getwhiteColours: setAdminApi('common/whiteColours'), //是否黑白
  // 广告
  getadInfo: setAdminApi('ad/info'), //启动页广告
  // 公共
  getDictList: setAdminApi('common/dictList'), //字典辅助接口
  // 用户
  postUserLogin: setAdminApi('user/login'), //登录
  postUserSendSms: setAdminApi('user/sendSms'), //发送短信验证码
  postUserRegister: setAdminApi('user/userRegister'), //注册
  postUserResetPassword: setAdminApi('user/resetPassword'), //重置密码
  postUserUpdateUserInfo: setAdminApi('user/updateUserInfo'), //更新用户信息
  // 栏目
  getnodeColumnList: setAdminApi('node/columnList'), //栏目列表
  getnodeColumnDetail: setAdminApi('node/columnDetail'), //栏目详情
  // 文章
  getarticleCommentList: setAdminApi('article/commentList'), //文章详情 - 评论列表
  getarticleList: setAdminApi('article/list'), //文章列表
  getarticleDetails: setAdminApi('article/details'), //文章详情
  getarticleSpecialList: setAdminApi('article/specialList'), //专题列表
  getarticleIndexStick: setAdminApi('article/indexStick'), //首页置顶新闻
  getarticleCorrelationList: setAdminApi('article/correlationList'), //相关新闻列表
  getarticleListwaterfall: setAdminApi('article/listwaterfall'), //首页瀑布流
  getarticleListvillages: setAdminApi('article/listvillages'), //乡镇新闻
  // 政务 start
  getTelephoneList: setAdminApi('political/telephoneListDetails'), //电话列表详情
  getTransactionList: setAdminApi('political/transactionList'), //马上办列表展示
  postTransactionDetails: setAdminApi('political/transactionDetails'), //马上办详情展示
  getOrgList: setAdminApi('political/orgList'), //马上办部门展示
  getFeedbackRanking: setAdminApi('political/feedbackRanking'), //反馈排名
  postTransactionSave: setAdminApi('political/transactionSave'), //马上办添加
  // 政务 end
  // 媒体 start
  getmediaHome: setAdminApi('media/home'), //媒体首页
  getmediaChannelDetail: setAdminApi('media/channelDetail'), //电视直播详情
  getmediaVodShowMore: setAdminApi('media/vodShowMore'), //节目点播、电影、音乐更多接口
  getmediaTvShowDetail: setAdminApi('media/tvShowDetail'), //电视直播回看
  getmediaChannelMore: setAdminApi('media/channelMore'), //电视广播直播更多接口
  getmediaVodDetail: setAdminApi('media/vodDetail'), //影视节目详情接口
  getmediaPaperMore: setAdminApi('media/paperMore'), //报纸更多接口
  postWatchlogSave: setAdminApi('common/watchlogSave'), //视听浏览时长的添加
  // 媒体 end
  // 生活圈 start
  postActivityCirclesList: setAdminApi('circles/activityCirclesList'), //朋友圈活动列表
  getActivityCirclesDetails: setAdminApi('circles/activityCirclesSelect'), //朋友圈活动详情
  postActivityCirclesSave: setAdminApi('circles/activitySeedSave'), //朋友圈活动报名
  postNeedMenuList: setAdminApi('circles/needMenuList'), //有需要您说话点单列表
  postNeedSave: setAdminApi('circles/needSave'), //有需要您说话添加
  getVolunteerSelect: setAdminApi('circles/volunteerSelect'), //志愿者已注册，返回注册信息
  postVolunteerSave: setAdminApi('circles/volunteerSave'), //志愿者注册
  postVolunteerUpdate: setAdminApi('circles/volunteerUpdate'), //志愿者修改
  postCirclesList: setAdminApi('circles/circlesList'), //生活圈列表
  postCirclesDetails: setAdminApi('circles/circlesDetails'), //生活圈详情
  postCirclesSave: setAdminApi('circles/circlesSave'), //新增用户发布朋友圈
  postCirclesPraiseCirclesSave: setAdminApi('circles/praiseCirclesSave'), //新增朋友圈点赞列表
  getCirclesPraiseCirclesList: setAdminApi('circles/praiseCirclesList'), //朋友圈点赞列表
  getCirclesCommentCirlesList: setAdminApi('circles/commentCirlesList'), //朋友圈评论显示
  getcityLifeList: setAdminApi('circles/cityLifeList'), //同城生活APP，列表
  getCirclescityLifeDetails: setAdminApi('circles/cityLifeDetails'), //同城生活APP，生活详情
  // 个人中心
  postMyCommentSave: setAdminApi('my/commentSave'), //评论新增
  postMyFavoriteYN: setAdminApi('my/favoriteYN'), //查看用户是否收藏
  postMyFavoriteSave: setAdminApi('my/favoriteSave'), //收藏
  getMyFavorite: setAdminApi('my/favorite'), //收藏列表
  getMyCommentList: setAdminApi('my/commentList'), //评论列表
  postMyGuestbookSave: setAdminApi('my/guestbookSave'), //意见反馈
  // 积分
  getMyAutonymSelect: setAdminApi('my/autonymSelect'), //实名认证查询
  postMyAutonymUpdate: setAdminApi('my/autonymUpdate'), //实名认证
  postIntegralSignIndex: setAdminApi('integral/signIndex'), //签到首页
  postIntegralSave: setAdminApi('integral/integralSave') //积分添加
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js